import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { deleteExpressParams, getExpressParams, postExpress, putExpress } from '../../../service/api';
import LabelManagerMain from '../../presentation/section/label-manager-page/LabelManagerMain';


const toLabelSelectList = (labelList, selectedLabelID) => {
  let options = [];

  if(Array.isArray(labelList) && labelList.length !== 0) {
    labelList.filter((item)=>item.labelID != selectedLabelID).forEach(item => {
      let pushItem = {};
      pushItem.value = item.name;
      pushItem.id = item.labelID;
      pushItem.label = item.name;
      options.push(pushItem); 
    })
  }

  return options;
}

const LabelManager = (props) => {
  const [userLabelData, setUserLabelData] = useState(null)
  const [selectedLabelData, setSelectedLabelData] = useState({
    labelID: -1,
    labelName: '',
    queryItem : [],
    reportItem: [],
    snapshotItem: [],
    customItem: []
  })
  const [checkedItemList, setCheckedItemList] = useState([]);
  const [createLabelName, setCreateLabelName] = useState('')
  const [targetLabelSelectOption, setTargetLabelSelectOption] = useState([{value:"none", id:"null", label:"none"}])
  const [targetLabel, setTargetLabel] = useState(-1)

  const [nameChangeShow, setNameChangeShow] = useState(false);
  const handleNameChangeShow = () => setNameChangeShow(true);
  const handleNameChangeClose = () => {
    setChangeLabelName('');
    setNameChangeShow(false)
  };
  const [changeLabelName, setChangeLabelName] = useState('');

  useEffect(()=> {
    getUserLabelData((res)=>{

      let labelArray = [...res.info, {labelID: "null", name:"none"}]
      setUserLabelData({
        type: res.type,
        name: res.name,
        info: labelArray
      })
    })
  }, [])

  useEffect(() => {
    if(userLabelData && Array.isArray(userLabelData.info) && userLabelData.info.length !== 0){
      setTargetLabelSelectOption(toLabelSelectList(userLabelData.info, selectedLabelData.labelID));
    }
  // }, [userLabelData]);
  }, [selectedLabelData]);

  useEffect(() => {
  }, [checkedItemList])

  const selectTargetLabel = (e) => {
    //e.id
    if (e) {
      setTargetLabel(e.id)
    }
    else {  
      setTargetLabel(-1);
    }
  }

  const handleCreateInput = (e) => {
    setCreateLabelName(e.target.value)
  }

  const handleLabelListClick = (item) => {
    //item.labelID
    let clickedLabelID = "null";
    if (item.labelID !== "null"){    
      clickedLabelID = item.labelID;
    }

    setSelectedLabelData({
      labelID: -1,
      labelName: '',
      queryItem : [],
      reportItem: [],
      snapshotItem: [],
      customItem: []
    })

    setCheckedItemList([]);
    setTargetLabel(-1);
    getExpressParams('/query/label/labelid/all', {
      labelID: clickedLabelID,
      email: props.currentUser
    }, (response) => {
      setSelectedLabelData(
        {
          labelID: clickedLabelID,
          labelName: item.name,
          queryItem : response.data.queryentity,
          reportItem: response.data.reportentity,
          snapshotItem: response.data.snapshotentity,
          customItem: response.data.customentity
        }
      )
    })
  }

  const createLabel = () => {
    if(createLabelName == '') {
    }
    else {
      postExpress('/query/label/userid', {
        email: props.currentUser,
        labelName: createLabelName
      }, (res) => {
        getUserLabelData((res)=>{
          let labelArray = [...res.info, {labelID: "null", name:"none"}]
          setUserLabelData({
            type: res.type,
            name: res.name,
            info: labelArray
          })
        })
      })
      setCreateLabelName('');
      setSelectedLabelData({
        // labelID: selectedLabelData.labelID,
        // labelName: selectedLabelData.labelName,
        // queryItem : [],
        // reportItem: [],
        // snapshotItem: [],
        // customItem: []
        labelID: -1,
        labelName: '',
        queryItem : [],
        reportItem: [],
        snapshotItem: [],
        customItem: []
      })
  
      setCheckedItemList([]);
      setTargetLabel(-1)
    }
  }
  
  const getUserLabelData = (callback) => {
    getExpressParams('/query/label/userid/all', {
      email: props.currentUser
    }, (response) => {
      callback(response.data.BuzzLabel);
    })
  }

  const handleChangeLabelName = (changeName) => {
    putExpress('/query/label/userid/labelid', {
      "email": props.currentUser,
      "labelID": selectedLabelData.labelID,
      "labelName": changeName
    },
    (res) => {
      getUserLabelData((res)=>{
        let labelArray = [...res.info, {labelID: "null", name:"none"}]
        setUserLabelData({
          type: res.type,
          name: res.name,
          info: labelArray
        })
        setSelectedLabelData({
          labelID: -1,
          labelName: '',
          queryItem : [],
          reportItem: [],
          snapshotItem: [],
          customItem: []
        })
    
        getExpressParams('/query/label/labelid/all', {
          labelID: selectedLabelData.labelID,
          email: props.currentUser
        }, (response) => {
          setSelectedLabelData(
            {
              labelID: selectedLabelData.labelID,
              labelName: changeName,
              queryItem : response.data.queryentity,
              reportItem: response.data.reportentity,
              snapshotItem: response.data.snapshotentity,
              customItem: response.data.customentity
            }
          )
          setTargetLabel(-1)
        })
      })
    })
  }


  const handleAllSelect = () => {

  }

  const handleAllDeSelect = () => {
  }

  const handleCheckBox = (type, id, checked) => {
    if (checked) {
      setCheckedItemList([...checkedItemList, {"type": type, "id": id}])
    }
    else {
      setCheckedItemList(checkedItemList.filter((item)=> item.type!=type || (item.type==type && item.id != id)));
    }
  }

  const handleMoveItem = () => {
    if(targetLabel != -1){
      checkedItemList.forEach((item) => {
        let sendJson = {
          "email": props.currentUser,
          "targetID": targetLabel
        };
        sendJson[item.type+'ID'] = item.id;
        putExpress(`/query/${item.type}-content/${item.type}id/labelid`, sendJson,
        (response) => {
          
        })
      })
    }
    else {}

    setSelectedLabelData({
      // labelID: selectedLabelData.labelID,
      // labelName: selectedLabelData.labelName,
      // queryItem : [],
      // reportItem: [],
      // snapshotItem: [],
      // customItem: []
      labelID: -1,
      labelName: '',
      queryItem : [],
      reportItem: [],
      snapshotItem: [],
      customItem: []
    })

    setCheckedItemList([]);
    setTargetLabel(-1);
  } 

  const handleRemoveItem = () => {
    checkedItemList.forEach((item) => {
      let sendJson = {
        "email": props.currentUser,
      };
      sendJson[item.type+'ID'] = item.id;
      deleteExpressParams(`/query/${item.type}-content/${item.type}id`, sendJson,
      (response) => {

      })
    })

    setSelectedLabelData({
      // labelID: selectedLabelData.labelID,
      // labelName: selectedLabelData.labelName,
      // queryItem : [],
      // reportItem: [],
      // snapshotItem: [],
      // customItem: []
      labelID: -1,
      labelName: '',
      queryItem : [],
      reportItem: [],
      snapshotItem: [],
      customItem: []
    })

    setCheckedItemList([]);
    setTargetLabel(-1);
  }
  
  const handleRemoveLabel = () => {
    deleteExpressParams(`/query/label/userid/labelid`, {
      email: props.currentUser,
      labelID: selectedLabelData.labelID
    }, (response) => {
      getUserLabelData((res)=>{
        let labelArray = [...res.info, {labelID: "null", name:"none"}]
        setUserLabelData({
          type: res.type,
          name: res.name,
          info: labelArray
        })
        setSelectedLabelData({
          labelID: -1,
          labelName: '',
          queryItem : [],
          reportItem: [],
          snapshotItem: [],
          customItem: []
        })
    
        setCheckedItemList([]);
        setTargetLabel(-1);
    })
    //label만 주고 back에서 계단식으로 삭제하고 마지막에 label삭제
  })
  }

  const handleChangeLabelNameInput = (event) => {
    setChangeLabelName(event.target.value);
  }


  return (
    <>
      <LabelManagerMain userLabelData={userLabelData} handleLabelListClick={handleLabelListClick} 
      selectedLabelData={selectedLabelData} createLabel={createLabel} createLabelName={createLabelName} handleCreateInput={handleCreateInput}
      targetLabelSelectOption={targetLabelSelectOption} selectTargetLabel={selectTargetLabel}
      handleChangeLabelNameInput={handleChangeLabelNameInput} handleNameChangeShow={handleNameChangeShow} handleNameChangeClose={handleNameChangeClose} nameChangeShow={nameChangeShow}
      changeLabelName={changeLabelName} handleChangeLabelName={handleChangeLabelName} handleCheckBox={handleCheckBox} handleMoveItem={handleMoveItem} handleRemoveItem={handleRemoveItem}
      handleRemoveLabel={handleRemoveLabel}
      />
    </>
  )
}

const mapStateToProps = (state) => ({
  currentUser: state.AuthManager.status.currentUser
})

export default connect(mapStateToProps) (LabelManager);